import { AxiosInstance } from 'axios';
import { T_LeadsNature } from '../types';

export class NotificationService {
  private notifAgent: AxiosInstance;
  constructor(agent: AxiosInstance) {
    this.notifAgent = agent;
  }
  public getLeads = async () => {
    try {
      const { data } = await this.notifAgent.get<T_LeadsNature>(`/my-account/lead`, {});
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };
}
